import React, { useState, useEffect } from "react";
import { contvertHTMLToPlain } from "../../../../utils/constants";
import Plot from "../../../../utils/customPlotly";
import { isMobile } from "../../../../utils/deviceInfo";
import Plotly from "plotly.js";

export default function OptionsPiechart({
  question,
  option_response_matching_records,
  isFilterApplied,
}) {
  const [values, setValues] = useState([]);
  const [labels, setLabels] = useState([]);
  const [formattedLabels, setFormattedLabels] = useState([]);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    // compute your data
    const numVals = question.options.map((option) => {
      const option_doc = isFilterApplied
        ? option_response_matching_records.find(
            (x) => x && x._id === (option && option.option_id)
          )
        : option;
      return (
        (option_doc && option_doc.totalResponses) ||
        (option_doc && option_doc.totalResponded) ||
        0
      );
    });
    const strLabels = question.options.map((option) =>
      contvertHTMLToPlain(option && option.text)
    );
    const fmtLabels = strLabels.slice(); // already plain text

    setValues(numVals);
    setLabels(strLabels);
    setFormattedLabels(fmtLabels);
    setColors(getPlotlyColors(question.options.length));
  }, [question, option_response_matching_records, isFilterApplied]);

  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <Plot
          data={[
            {
              type: "pie",
              values,
              labels,
              marker: { colors },
              textinfo: "percent",
              textposition: "inside",
              automargin: true,
              hovertemplate: "%{label}<br>%{percent}<extra></extra>",
              hoverlabel: { namelength: -1 },
              textfont: { size: isMobile ? 10 : 12 },
              insidetextorientation: "horizontal",
            },
          ]}
          layout={{
            showlegend: false,
            height: isMobile ? 300 : 400,
            width: isMobile ? 300 : 500,
            margin: { t: 20, l: 20, r: 20, b: 20 },
            autosize: true,
          }}
          config={{ displayModeBar: false }}
        />
      </div>

      <div className={"plotly-legend-div-container"}
        style={{
          width: "100%",
          padding: "10px",
          backgroundColor: "#f5f5f5",
          borderRadius: "5px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {formattedLabels.map((lbl, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: colors[i],
                  marginRight: "10px",
                  flexShrink: 0,
                  borderRadius: "2px",
                }}
              />
              <div style={{ whiteSpace: "pre-line" }}>{lbl}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// pull directly from Plotly's D3 scales
function getPlotlyColors(count) {
  // category10 and category20 provide up to 20 distinct hues
  const d3 = Plotly.d3;
  const cat10 = d3.scale.category10().range();
  const cat20 = d3.scale.category20().range();

  const palette = [...cat10, ...cat20];
  return palette.slice(0, count);
}
